/**
 * Shared constants for user management UI.
 */

export const VALID_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'planner', label: 'Planner' },
  { value: 'activation', label: 'Activation' },
  { value: 'creative_agency', label: 'Creative Agency' },
  { value: 'approver', label: 'Approver' },
  { value: 'viewer', label: 'Viewer' },
  { value: 'asset_manager', label: 'Asset Manager' },
];

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  planner: 'Planner',
  activation: 'Activation',
  creative_agency: 'Creative Agency',
  approver: 'Approver',
  viewer: 'Viewer',
  asset_manager: 'Asset Manager',
};

export const ROLE_COLORS: Record<string, string> = {
  admin: 'bg-purple-100 text-purple-700',
  planner: 'bg-blue-100 text-blue-700',
  activation: 'bg-green-100 text-green-700',
  creative_agency: 'bg-orange-100 text-orange-700',
  approver: 'bg-pink-100 text-pink-700',
  viewer: 'bg-slate-100 text-slate-700',
  asset_manager: 'bg-teal-100 text-teal-700',
};

export const ROLE_PRIORITY: Record<string, number> = {
  admin: 0,
  planner: 1,
  activation: 2,
  creative_agency: 3,
  approver: 4,
  viewer: 5,
  asset_manager: 6,
};

export const VALID_MARKETS = ['NO', 'FR', 'IT', 'ES', 'DE', 'AT', 'CH', 'UK'];

/** Suite applications a user can be granted access to (mirrors backend AppAccess enum). */
export const VALID_APP_ACCESS = [
  { value: 'content_tracker', label: 'Content Tracker' },
  { value: 'asset_library', label: 'Asset Library' },
];

/** Derived so a new app only has to be added to VALID_APP_ACCESS above. */
export const APP_ACCESS_LABELS: Record<string, string> = Object.fromEntries(
  VALID_APP_ACCESS.map(({ value, label }) => [value, label]),
);
